import { IWarOfBetsGameState, IWarOfBetsSelectData } from './interfaces';

export const warOfBetsSelectors = {
    selectData: (state: IWarOfBetsGameState): IWarOfBetsSelectData => ({
        ...state.data,
        mainBettingOptions: state.oddGroups[0].ids.map((id) => state.data.bettingOptions[id]),
        dealerBettingOptions: [531, 532, 536, 537, 535, 538].map(
            (id) => state.data.bettingOptions[id],
        ),
        dealerNumberBettingOptions: [550, 549, 544, 543, 545].map(
            (id) => state.data.bettingOptions[id],
        ),
        playerBettingOptions: [540, 541, 539, 542, 533, 534].map(
            (id) => state.data.bettingOptions[id],
        ),
        playerNumberBettingOptions: [547, 546, 548, 552, 551].map(
            (id) => state.data.bettingOptions[id],
        ),
        oddsGroups: state.oddGroups,
    }),
};
